import { render, staticRenderFns } from "./25Auguest.vue?vue&type=template&id=2fa9c25c"
import script from "./25Auguest.vue?vue&type=script&lang=js"
export * from "./25Auguest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports